import UserPermissionsCrud from './UserPermissionsCrud.vue'
export { UserPermissionsCrud }
export default UserPermissionsCrud
